// extracted by mini-css-extract-plugin
export default {"alert_box_container":"AlertBox-module_alert_box_container__eBnDn","alert_box_container_with_padding":"AlertBox-module_alert_box_container_with_padding__GuzRE"};